import React, { Component } from "react";
import {
  InputGroup,
  InputGroupAddon,
  Input,
  Row,
  Col,
  Button,
  Table
} from "reactstrap";

import Collapsible from 'react-collapsible';
import { reduxForm } from 'redux-form'
import { connect } from 'react-redux';
import BlockUi from 'react-block-ui';
import 'react-block-ui/style.css';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { currentDate } from '../../../lib/common'
import Moment from "react-moment";
import { storedb } from '../../client/storedb'
import Pagination from "react-js-pagination";
import * as importReportConstant from './constants'
import * as importReportAction from './actions'
import DisplayRecordText from "../../controls/_DisplayRecordText"
import CheckboxTreeList from "../../controls/_CheckboxTreeList";
class ImportReport extends Component {
  constructor(props) {
    super(props);
    var dbContext = storedb();
    this.state = {
      store_id: dbContext.getStoreId(),
      tuNgay: currentDate().startOf('month'),
      denNgay: currentDate(),
      item: {},
      list: [],
      total_record: 0,
      tong_soLuong: 0,
      tong_diem: 0,
      tong_tien: 0,
      page: 1,
      per_page: 20,

      multipleValueNhaCC: [],
      multipleValueKho: [],
      treeKho: [],
      treeNhaCC: [],
      trangThai: "",
      keyword: ""
    };
    this.handleDateChange = this.handleDateChange.bind(this);
  }
  handleDateChange(name, e, value) {
    switch (name) {
      case "tuNgay":
        this.setState({ tuNgay: e });
        break;
      case "denNgay":
        this.setState({ denNgay: e });
        break;
    }
  }
  handleSearchChange = (name, e, value) => {
    switch (name) {
      case "keyword":
        this.setState({ keyword: e.target.value });
        break;
      default:
        break;
    }
  }
  handleSelectChange = (name, selectedOption) => {
    switch (name) {
      case "TrangThai":
        this.setState({ trangThai: selectedOption.target.value })
        break;
      default:
        break;
    }
  }
  onHandleRemoveNhaCC = () => {
    this.setState({ multipleValueNhaCC: [] })
  }
  onHandleChoiceNhaCC = (nodesChecked) => {
    var multipleValue = [];
    nodesChecked.forEach(function (item) {
      if (item.value != 0) {
        multipleValue.push(item.value);
      }
    });
    this.setState({ multipleValueNhaCC: multipleValue })
  }

  onHandleRemoveKho = () => {
    this.setState({ multipleValueKho: [] })
  }
  onHandleChoiceKho = (nodesChecked) => {
    var multipleValue = [];
    nodesChecked.forEach(function (item) {
      if (item.value != 0) {
        multipleValue.push(item.value);
      }
    });
    this.setState({ multipleValueKho: multipleValue })
  }
  fetchNhaCC = () => {
    const { importReportNhaCCRequest } = this.props

    var requestData = {
      stores_id: this.state.store_id,
      page: 1,
      per_page: 200
    };
    return importReportNhaCCRequest(requestData);
  }
  fetchKho = () => {
    const { importReportKhoRequest } = this.props
    var requestData = {
      StoreId: this.state.store_id,
      keyword: null,
      status: null,
      cap: 1,
      page: 1,
      per_page: 200
    };
    return importReportKhoRequest(requestData);
  }
  handlePageChange = (pageNumber) => {
    let page = parseInt(pageNumber || 1)
    return this.setState({ page }, this.fetchList);
  }
  fetchList(page) {
    const { importReportListRequest } = this.props

    var requestData = {
      tu_ngay: this.state.tuNgay ? this.state.tuNgay.unix() : '',
      den_ngay: this.state.denNgay ? this.state.denNgay.endOf('days').unix() : '',
      store_id: this.state.store_id,
      listNcc: this.state.multipleValueNhaCC,
      listKho: this.state.multipleValueKho,
      keyword: this.state.keyword,
      trangThai: this.state.trangThai,
      page: page || this.state.page,
      per_page: this.state.per_page
    }
    return importReportListRequest(requestData)
  }
  exportXls = () => {
    const { importExportXlsRequest } = this.props

    var requestData = {
      tu_ngay: this.state.tuNgay ? this.state.tuNgay.unix() : '',
      den_ngay: this.state.denNgay ? this.state.denNgay.endOf('days').unix() : '',
      store_id: this.state.store_id,
      listNcc: this.state.multipleValueNhaCC.join(","),
      listKho: this.state.multipleValueKho.join(","),
      keyword: this.state.keyword,
      trangThai: this.state.trangThai,
    };
    return importExportXlsRequest(requestData, (listEXP) => {
      var dataFile = new Blob([listEXP], {
        type: "application/vnd.ms-excel;charset=UTF-8"
      });
      var fileURL = URL.createObjectURL(dataFile);
      var id = 'dlinkExportNhap';
      var fileName = "baocao_nhaphang.xls";
      var link = document.getElementById(id);
      if (link == null) {
        var a = document.createElement('a');
        a.style = "display:none;";
        a.id = "dlinkExportNhap";
        document.body.appendChild(a);
        link = a;
      }
      var filename = prompt("File name", fileName);
      if (filename) {
        link.href = fileURL;
        link.download = filename;
        link.click();
        link.remove();
      }
    });
  }
  search = () => {
    if (this.props.importReport.listRequesting) {
      return false;
    }
    return this.setState({ page: 1 }, () => {
      this.fetchList(1);
    });
  }
  keyPress = (e) => {
    if (e.keyCode == 13) {
      this.search()
    }
  }
  onChangeItem = (itemPerPage) => {
    this.setState({ per_page: itemPerPage }, () => {
      this.search();
    });
  }
  componentDidMount() {
    this.fetchKho();
    this.fetchNhaCC();
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.importReport.type == importReportConstant.IMPORT_REPORT_NCC_SUCCESS) {
      var listNcc = nextProps.importReport.listNCC.map((it, idx) => {
        return {
          Name: it.Ten,
          Id: it.NhaCCId,
        };
      });
      if (listNcc && listNcc.length === 1) {
        // neu chi co 1 minh no thì thực hiện set luôn user đó
        const NccChecked = listNcc.map((item) => { return { value: item.Id } })
        this.onHandleChoiceNhaCC(NccChecked)
      };
      this.setState({
        treeNhaCC: listNcc
      });
    }
    else if (nextProps.importReport.type == importReportConstant.IMPORT_REPORT_KHO_SUCCESS) {
      var listkho = nextProps.importReport.listKHO.map((it, idx) => {
        return {
          Name: it.Ten,
          Id: it.KhoId,
        };
      });
      this.setState({
        treeKho: listkho
      });
    }
    if (nextProps.importReport.type == importReportConstant.IMPORT_REPORT_LIST_SUCCESS) {
      let { list, item } = nextProps.importReport;
      this.setState({
        page: item.page,
        per_page: item.per_page,
        total_record: item.total_record,
        tong_soLuong: item.tong_soLuong,
        tong_nhapChuaCK: item.tong_nhapChuaCK,
        tong_nhapSauCK: item.tong_nhapSauCK,
        list: list
      });
    }
  }
  render() {
    const { list,
      treeNhaCC,
      treeKho
    } = this.state
    const {
      handleSubmit,
      importReport: {
        listRequesting
      },
    } = this.props
    return (
      <div className="animated fadeIn report">
        <BlockUi tag="div" blocking={listRequesting} >
          <div>
            <Collapsible trigger="Thống kê báo cáo..." overflowWhenOpen="inherit" open={true}>
              <Row className="report-control">
                <Col sm="2" xs="6" className="mb-2 pr-0 half-left">
                  <InputGroup size="md">
                    <span className="add_date_exs_span">Từ:</span>
                    <DatePicker
                      dateFormat="DD/MM/YYYY"
                      name="tuNgay" placeholder="Từ ngày"
                      selected={this.state.tuNgay}
                      onChange={this.handleDateChange.bind(this, "tuNgay")}
                      required className={"form-control add_date_exs_input"} />
                  </InputGroup>
                </Col>
                <Col sm="2" xs="6" className="mb-2 pr-0 half-right">
                  <InputGroup size="md">
                    <span className="add_date_exs_span">Đến:</span>
                    <DatePicker
                      dateFormat="DD/MM/YYYY"
                      name="denNgay" placeholder="đến ngày"
                      selected={this.state.denNgay}
                      onChange={this.handleDateChange.bind(this, "denNgay")}
                      required className={"form-control add_date_exs_input"} />
                  </InputGroup>
                </Col>
                <Col sm="3" className="mb-2">
                  <InputGroup size="md">
                    <select className="form-control" value={this.state.trangThai} onChange={this.handleSelectChange.bind(this, "TrangThai")}>
                      <option value="">Trạng thái</option>
                      <option value={0}>Chưa duyệt</option>
                      <option value={1}>Đã duyệt</option>
                    </select>
                  </InputGroup>
                </Col>
                <Col sm="3" className="mb-2">
                  <InputGroup size="md">
                    <Input name="keyword"
                      placeholder="Tìm tên hoặc mã"
                      value={this.state.keyword}
                      onChange={this.handleSearchChange.bind(this, "keyword")}
                      onKeyDown={e => this.keyPress(e)} />
                  </InputGroup>
                </Col>
                <Col sm="6" className="mb-2">
                  <InputGroup size="md">
                    <CheckboxTreeList
                      placeholder={`--Nhà cung cấp--`}
                      nodes={treeNhaCC}
                      isMultiChoice={false}
                      checked={this.state.multipleValueNhaCC}
                      onHandleRemove={(item) => this.onHandleRemoveNhaCC(item)}
                      onChoice={e => this.onHandleChoiceNhaCC(e)}
                    />
                  </InputGroup>
                </Col>
                <Col sm="6" className="mb-2">
                  <InputGroup size="md">
                    <CheckboxTreeList
                      placeholder={`--Kho nhập--`}
                      nodes={treeKho}
                      isMultiChoice={false}
                      checked={this.state.multipleValueKho}
                      onHandleRemove={(item) => this.onHandleRemoveKho(item)}
                      onChoice={e => this.onHandleChoiceKho(e)}
                    />
                  </InputGroup>
                </Col>

              </Row>
            </Collapsible>
          </div>
          <div className="w-100 mb-2 mt-2 mb-2">
            <Button size="md" color="success" className="mr-1" onClick={handleSubmit(this.search)}><i className="fa fa-search"></i> Thống kê</Button>&nbsp;
            <Button size="md" color="primary" className="mr-1" onClick={this.exportXls.bind(this, {})}><i className="fa fa-file-excel-o"></i> Xuất excel</Button>
          </div>
          <div className="mt-2 bg-white">
            <div className="w-100">
              <DisplayRecordText
                itemsCountPerPage={this.state.per_page}
                onChangeItem={this.onChangeItem}
              />
              <Table hover responsive className="table-outline mb-0 d-sm-table table-sm">
                <thead className="thead-default">
                  <tr>
                    <th scope="col" width="50" className="text-center">#</th>
                    <th scope="col" className="text-left">Kho</th>
                    <th scope="col" className="text-left">Số phiếu</th>
                    <th scope="col" className="text-left">Ngày lập</th>
                    <th scope="col" className="text-left">Mã thuốc</th>
                    <th scope="col" className="text-left">Tên thuốc</th>
                    <th scope="col" className="text-right">Số lượng</th>
                    <th scope="col" className="text-right">Giá nhập</th>
                    <th scope="col" className="text-right">Thành tiền chưa CK</th>
                    <th scope="col" className="text-right">Thành tiền sau CK</th>
                    <th scope="col" className="text-left">Ghi chú</th>
                    <th scope="col" className="text-left">Trạng thái</th>
                  </tr>
                </thead>
                <tfoot>
                  <tr>
                    <th scope="col" colSpan="7" className="text-right">
                      Tổng cộng:
                     <span className="text-success">
                        {this.state.tong_soLuong &&
                          this.state.tong_soLuong.toLocaleString("vi-VN",
                            { minimumFractionDigits: 0 })}</span>
                    </th>
                    <th scope="col" className="text-right">
                    </th>
                    <th scope="col" className="text-right">
                      <span className="text-success">
                        {this.state.tong_nhapChuaCK &&
                          this.state.tong_nhapChuaCK.toLocaleString("vi-VN",
                            { minimumFractionDigits: 0 })} ₫</span>
                    </th>
                    <th scope="col" className="text-right">
                      <span className="text-success">
                        {this.state.tong_nhapSauCK &&
                          this.state.tong_nhapSauCK.toLocaleString("vi-VN",
                            { minimumFractionDigits: 0 })} ₫</span>
                    </th>

                    <th scope="col" colSpan="2" className="text-right">
                    </th>
                  </tr>
                </tfoot>
                <tbody>
                  {list && !!list.length && (
                    list.map((res, idx) => (
                      <tr key={idx + 1}>
                        <td className="text-center">{idx + 1}</td>
                        <td className="text-left">{res.TenKho}</td>
                        <td className="text-left">{res.So}</td>
                        <td className="text-left">{res.NgayNhap && <Moment tz={'UTC'} format="HH:mm DD/MM">{`${res.NgayNhap}`}</Moment>}</td>
                        <td className="text-left">{res.Sku}</td>
                        <td className="text-left">{res.TenHang}</td>
                        <td className="text-right">{res.SoLuong}</td>
                        <td className="text-right">{res.GiaNhap}</td>
                        <td className="text-right">{res.tong_nhapChuaCK}</td>
                        <td className="text-right">{res.tong_nhapSauCK}</td>
                        <td className="text-left">{res.GhiChu}</td>
                        <td className="text-left">{res.TenTrangThai}</td>
                      </tr>
                    ))
                  )}
                </tbody>

              </Table>
              {this.state.total_record > this.state.per_page && (
                <Pagination
                  activePage={this.state.page}
                  itemsCountPerPage={this.state.per_page}
                  totalItemsCount={this.state.total_record}
                  pageRangeDisplayed={5}
                  onChange={this.handlePageChange}
                />
              )}
            </div>
            <div className="clearfix"></div>
          </div>
        </BlockUi>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  importReport: state.importReport,
  client: state.client,
})

const connected = connect(mapStateToProps, {
  importReportListRequest: importReportAction.importReportListRequest,
  importReportKhoRequest: importReportAction.importReportKhoRequest,
  importReportNhaCCRequest: importReportAction.importReportNhaCCRequest,
  importExportXlsRequest: importReportAction.importExportXlsRequest
})(ImportReport)

const formed = reduxForm({
  form: 'importReport',
})(connected)

export default formed;




// WEBPACK FOOTER //
// ./src/views/Reports/ImportReport/ImportReport.js